import { TextBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/textBlock/textBlock.layout'
import { slugify } from '@shared/Frontend/utils/slugify'
import * as React from 'react'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState, Link } from '../../../../cms/blocks/types.gen'

export type textBlockProps = {
  index: number
  title?: string
  text: string
  primary_button?: (
    | { kind: 'button'; on_click: () => Updater<CMSState> }
    | Link
  ) & {
    title: string
  }
  link?: Link
  link_type: boolean
}

export function textBlock(
  props: textBlockProps
): (
  s: CMSState
) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState) => (public_state: PublicSiteState) =>
    fromJSX(() => (
        <>
          <TextBlockLayout
            id={slugify(props.title)}
            title={props.title}
            text={props.text}
            primaryUpdater={
              props.primary_button && props.primary_button.kind == 'link'
                ? {
                    ...props.primary_button,
                    isExternal: props.primary_button.is_link_external
                  }
                : undefined
            }
            secondaryUpdater={
              props.link && props.link.title && props.link.url
                ? {
                    ...props.link,
                    isExternal: props.link.is_link_external
                  }
                : undefined
            }
          />
        </>
      )
    )
}
